import React from 'react';

export default function Button({ children, loading, variant = 'primary', ...props }) {
  const base = {
    width: '100%',
    padding: '11px 20px',
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: "'Space Grotesk', sans-serif",
    border: 'none',
    borderRadius: 'var(--radius)',
    cursor: loading ? 'not-allowed' : 'pointer',
    transition: 'background 0.15s ease, transform 0.1s ease',
    letterSpacing: '0.01em',
  };
  const variants = {
    primary: {
      background: 'var(--accent)',
      color: 'var(--on-accent)',
    },
    ghost: {
      background: 'transparent',
      color: 'var(--accent)',
      border: '1px solid var(--border)',
    },
  };
  return (
    <button
      {...props}
      disabled={loading || props.disabled}
      style={{ ...base, ...variants[variant], opacity: loading ? 0.7 : 1 }}
    >
      {loading ? 'Please wait...' : children}
    </button>
  );
}
